<div class="card-body">
    <div id="apex-basic-area-chart"></div>
</div>